import { paymentsApi } from '.';

export interface GocardlessVerifyBankData {
  bank: string,
  verified: boolean,
}

export interface GocardlessVerifyBankRequest {
  client: string,
  sortCode: string,
  accountNumber: string,
}

export interface GocardlessVerifyBankResponse {
  data: GocardlessVerifyBankData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    gocardlessVerifyBank: builder.mutation<GocardlessVerifyBankResponse, GocardlessVerifyBankRequest>({
      query: body => ({
        url: 'provider/go-cardless/verify-bank',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useGocardlessVerifyBankMutation } = extendedPaymentsApi;
